export const INTENTS = ["bill", "save"] as const;

export type Intent = (typeof INTENTS)[number];

export const isIntent = (value: string): value is Intent =>
  (INTENTS as readonly string[]).includes(value);

export type IntentData = { intent: Intent };

/**
 * Callers must pass `intent: undefined` explicitly, so a missing intent reads
 * as a deliberate signal rather than an omission.
 */
export type ResolvedIntentData = { intent: Intent | undefined };

export type HouseholdData = { householdSize: number };

/**
 * FFGA partner context resolved from the invite-token entry
 * (`resolveInviteToken`). Drives the partner-specific copy on ctx-driven
 * screens; `redeemed` marks a re-clicked invite link from an existing user,
 * which surfaces the log-in affordance prominently.
 */
export type FfgaData = {
  partnerName: string;
  redeemed: boolean;
};

export type CarrierData = { carrier: string };

/**
 * Subscriber identity as the profile step captured it. ISO `YYYY-MM-DD` for
 * the DOB — the eligibility 270 parses only that shape.
 */
export type OnboardingIdentity = {
  firstName: string;
  lastName: string;
  dateOfBirth: string;
};

export type IdentityData = { identity?: OnboardingIdentity };
